import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { connect } from "react-redux";
import { getRoster } from "../../actions/action_roster";
import { setCol1 } from "../../actions/action_roster";
import { setCol2 } from "../../actions/action_roster";
import { setCol3 } from "../../actions/action_roster";
import { setCurrTab } from "../../actions/action_roster";

class Roster extends Component {
  constructor(props) {

    const columns = [
      {Header: 'First',
        accessor: 'fname',
        Cell: props => <Link to={'/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.id}>{props.value}</Link>
      },
      {Header: 'Last',
        accessor: 'lname',
        Cell: props => <Link to={'/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.id}>{props.value}</Link>
      },
      {Header: 'Hometown', accessor: 'hometown'},
      {Header: 'Year',
        accessor: 'school_year',
        Cell: props => <span>{this.getYear(Number(props.value))}</span>
      },
      {Header: 'Events', accessor: 'events'},
    ];
    const columns2 = [
      {Header: 'First',
        accessor: 'fname',
        Cell: props => <Link to={'/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</Link>
      },
      {Header: 'Last',
        accessor: 'lname',
        Cell: props => <Link to={'/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</Link>
      },
      {Header: 'Floor', accessor: 'maxfx', width: 75},
      {Header: 'Phorse', accessor: 'maxph', width: 75},
      {Header: 'Rings', accessor: 'maxsr', width: 75},
      {Header: 'Vault', accessor: 'maxvt', width: 75},
      {Header: 'Pbars', accessor: 'maxpb', width: 75},
      {Header: 'Highbar', accessor: 'maxhb', width: 75},
      {Header: 'AA', accessor: 'maxaa'},
    ];
    const columnsSchedule = [
      {Header: 'Meet',
        accessor: 'meet_id',
        'width': 80,
        Cell: props => props.original.team_id === 0 ? '' : <a href={'/results/scheduleGA/meet/'+props.value}>View</a>
      },
      {Header: 'Date', accessor: 'meet_date', 'width': 140},
      {Header: 'Team Score',
        accessor: 'team_score',
        'width': 140,
        Cell: props => props.original.team_id === 0 ? '' : props.value
      },
      {Header: 'Home/Away', accessor: 'home', 'width': 120, Cell: props => props.original.team_id === 0 ? '' : props.value},
      {Header: 'Opponent', accessor: 'opponent', Cell: props => props.original.team_id === 0 ? '' : props.value},
      {Header: 'Desc', accessor: 'meet_desc'},
    ];
    super(props);

    this.props.setCol1(columns);
    this.props.setCol2(columns2);
    this.props.setCol3(columnsSchedule);

    this.handleScheduleClick = this.handleScheduleClick.bind(this);
    this.handleRosterClick = this.handleRosterClick.bind(this);
    this.handleHighClick = this.handleHighClick.bind(this);
    this.handleAverageClick = this.handleAverageClick.bind(this);
    this.handleRQSClick = this.handleRQSClick.bind(this);
    this.getYear = this.getYear.bind(this);
    this.defaultSortMethod = this.defaultSortMethod.bind(this);
  }
  getYear(year) {
    let text = '';
    if(year === 1) {
      text = 'FR';
    } else if(year === 2) {
      text = 'SO';
    } else if(year === 3) {
      text = 'JR';
    } else if(year === 4) {
      text = 'SR';
    }
    return text;
  }
  componentDidMount(){
    this.props.setCurrTab(1);
    /*this.props.getRoster({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "currTab": this.props.currTab
    });*/
  }
  componentDidUpdate(prevProps){
    if(this.props.currTab !== 1 && (prevProps.teamFilter !== this.props.teamFilter || prevProps.yearFilter !== this.props.yearFilter)){
      this.props.getRoster({
        "year": this.props.yearFilter,
        "team": this.props.teamFilter,
        "currTab": this.props.currTab
      });
    }
  }
  handleScheduleClick() {
    this.props.setCurrTab(1);
  }
  handleRosterClick() {
    this.props.getRoster({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "currTab": 2
    });
  }
  handleHighClick() {
    this.props.getRoster({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "currTab": 3
    });
  }
  handleAverageClick() {
    this.props.getRoster({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "currTab": 4
    });
  }
  handleRQSClick() {
    this.props.getRoster({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "currTab": 5
    });
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  render() {
    if(this.props.cols !== []){
      let schedule = this.props.currTab === 1 ? '' : ' secondary';
      let roster = this.props.currTab === 2 ? '' : ' secondary';
      let high = this.props.currTab === 3 ? '' : ' secondary';
      let average = this.props.currTab === 4 ? '' : ' secondary';
      let rqs = this.props.currTab === 5 ? '' : ' secondary';
      return (
        <div className="rosterBox">
          <div className="row expanded small-collapse">
            <div className="small-6 medium-2 columns">
              <button className={"button expanded"+schedule} onClick={this.handleScheduleClick}>Schedule</button>
            </div>
            <div className="small-6 medium-2 columns">
              <button className={"button expanded"+roster} onClick={this.handleRosterClick}>Roster</button>
            </div>
            <div className="small-5 medium-2 columns">
              <button className={"button expanded"+high} onClick={this.handleHighClick}>High</button>
            </div>
            <div className="small-4 medium-2 columns">
              <button className={"button expanded"+average} onClick={this.handleAverageClick}>Average</button>
            </div>
            <div className="small-4 medium-2 columns">
              <button className={"button expanded"+rqs} onClick={this.handleRQSClick}>NQS</button>
            </div>
            <div className="small-12 medium-2 columns">
            </div>
          </div>
          <div className="row expanded">
            <ReactTable
              className="-striped -highlight"
              data={this.props.currTab === 1 ? this.props.meets : this.props.scores}
              columns={this.props.cols}
              defaultSortMethod={this.defaultSortMethod}
              showPagination={false}
              defaultPageSize={this.props.currTab === 1 ? this.props.meets.length : this.props.numRows}
              pageSize={this.props.currTab === 1 ? this.props.meets.length : this.props.numRows}
            />
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }// end if
  }
}

function mapStateToProps(state) {
  return {
    scores : state.roster.scores,
    cols : state.roster.cols,
    col1 : state.roster.col1,
    col2 : state.roster.col2,
    numRows : state.roster.numRows,
    currTab : state.roster.currTab,
  };
}

export default connect(mapStateToProps, { getRoster, setCol1, setCol2, setCol3, setCurrTab })(Roster);
